import { ErrorInfo } from 'react';

export type ErrorContext = {
  title: string;
  message: string;
  exception: Error;
  info?: ErrorInfo;
  report: boolean;
};

export function getErrorDetails(error: Error, info?: ErrorInfo): ErrorContext {
  if ('name' in error && error.name === 'AxiosError') {
    if ('code' in error && error.code === 'ERR_NETWORK') {
      return {
        title: 'Network Error',
        message: `A network error occurred. Please check your internet connection and try again.`,
        exception: error,
        info: info,
        report: false
      };
    }
  }

  return {
    title: 'Error',
    message: `An unexpected error occurred: ${error.message}`,
    exception: error,
    info: info,
    report: true
  };
}
